import { useTranslation } from 'react-i18next';

import type { ShippingRateKind } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const STYLES: Record<ShippingRateKind, string> = {
  flat: 'border-border text-muted-foreground',
  weight: 'bg-primary/10 text-foreground border-transparent',
  price: 'bg-primary/10 text-foreground border-transparent',
  free_over: 'bg-success/15 text-success border-transparent dark:bg-success/20',
};

export function RateKindBadge({ kind, className }: { kind: ShippingRateKind; className?: string }) {
  const { t } = useTranslation('shipping');
  return (
    <Badge variant="outline" className={cn(STYLES[kind], className)}>
      {t(`rate.kind.${kind}`)}
    </Badge>
  );
}
